import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [3, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "video",
                  options: {
                    src: `${config.ASSETS_URL}/03/11/principle/sound-reflection.mov`,
                    loop: true,
                    autoplay: true,
                    muted: true,
                    controls: false,
                  },
                },
                styles: {
                  padding: "0 13%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "In this example the sound pressure level is visualized in a room. The sound source is a loudspeaker in the center of the room. Please notice that the sound wave is propagating considering wave based effects like scattering, diffraction and wave interference.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
